var productFormSelector = 'form[action*="cart/add"].product-buy-form-pdp';

function Elixir_ProductFormExists() {
    return document.querySelector(productFormSelector) !== null;
}

function Elixir_GetProductForm() {
    return document.querySelector(productFormSelector);
}

function Elixir_ProductFormHasItemsInputs() {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    return form.querySelector('input[name^="items["]') !== null;
}

// Returns the variant ID from the product form. In single-variant mode uses input[name="id"]; in items[] mode (e.g. Quantity Break) uses the first items[X][id] value so price/context use the correct variant.
function Elixir_GetProductFormVariantId() {
    var form = Elixir_GetProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    if (input && input.value) return input.value;
    if (Elixir_ProductFormHasItemsInputs()) {
        var firstId = form.querySelector('input[name^="items["][name*="][id]"]');
        if (firstId && firstId.value) return firstId.value;
    }
    return null;
}

// Returns the selling plan ID from the product form (input[name="selling_plan"]), or null if missing/empty.
function Elixir_GetProductFormSellingPlan() {
    var form = Elixir_GetProductForm();
    if (!form) return null;
    var input = form.querySelector('input[name="selling_plan"]');
    return input && input.value ? input.value : null;
}

// Sets the selling plan on the product form. Creates input[name="selling_plan"] if missing.
// Pass null, undefined or '' to clear (one-time purchase). Dispatches input and change events.
function Elixir_SetProductFormSellingPlan(sellingPlanId) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    var value = (sellingPlanId !== undefined && sellingPlanId !== null && sellingPlanId !== '') ? String(sellingPlanId) : '';
    var input = form.querySelector('input[name="selling_plan"]');
    if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        form.appendChild(input);
    }
    input.value = value;
    input.setAttribute('value', value);
    input.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    input.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));
    return true;
}

function Elixir_SetProductFormVariantId(variantId) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    var input = form.querySelector('input[name="id"]');
    if (input) {
        input.value = variantId !== undefined && variantId !== null && variantId !== '' ? String(variantId) : '';
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}

function Elixir_ProductFormSwitchToItemsMode(items, options) {
    var form = Elixir_GetProductForm();
    if (!form) return false;
    if (!items || !Array.isArray(items) || items.length === 0) return false;

    options = options || {};
    var containerClass = options.containerClass || 'product-form-items-container';
    var startIndex = options.startIndex !== undefined ? options.startIndex : 1;

    var existing = form.querySelector('.' + containerClass);
    if (existing) existing.remove();

    var container = document.createElement('div');
    container.className = containerClass;

    items.forEach(function (item, i) {
        var index = startIndex + i;
        var idIn = document.createElement('input');
        idIn.type = 'hidden';
        idIn.name = 'items[' + index + '][id]';
        idIn.value = String(item.id);
        idIn.className = 'product-variant-id';
        container.appendChild(idIn);

        var qtyIn = document.createElement('input');
        qtyIn.type = 'hidden';
        qtyIn.name = 'items[' + index + '][quantity]';
        qtyIn.value = String(item.quantity != null ? item.quantity : 1);
        container.appendChild(qtyIn);

        if (item.selling_plan != null && item.selling_plan !== '') {
            var planIn = document.createElement('input');
            planIn.type = 'hidden';
            planIn.name = 'items[' + index + '][selling_plan]';
            planIn.value = String(item.selling_plan);
            container.appendChild(planIn);
        }

        if (item.properties && typeof item.properties === 'object') {
            Object.keys(item.properties).forEach(function (key) {
                var propIn = document.createElement('input');
                propIn.type = 'hidden';
                propIn.name = 'items[' + index + '][properties][' + key + ']';
                propIn.value = String(item.properties[key]);
                container.appendChild(propIn);
            });
        }
    });

    var mainIdInput = form.querySelector('input[name="id"]');
    if (mainIdInput) mainIdInput.remove();

    form.appendChild(container);
    return true;
}

function Elixir_ProductFormSwitchToSingleIdMode(variantId, itemsContainerSelector) {
    var form = Elixir_GetProductForm();
    if (!form) return false;

    if (itemsContainerSelector) {
        var container = form.querySelector(itemsContainerSelector);
        if (container && (variantId === undefined || variantId === null || variantId === '')) {
            var firstIdInput = container.querySelector('input[name^="items["][name*="][id]"]');
            if (firstIdInput && firstIdInput.value) variantId = firstIdInput.value;
        }
        if (container) container.remove();
    }

    var input = form.querySelector('input[name="id"]');
    if (input) {
        if (variantId !== undefined && variantId !== null && variantId !== '') input.value = String(variantId);
        return true;
    }
    if (variantId === undefined || variantId === null || variantId === '') return true;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'id';
    input.value = String(variantId);
    input.className = 'product-variant-id';
    form.appendChild(input);
    return true;
}

function Elixir_InitProductFormQuantityListener() {
    document.addEventListener('change', function (e) {
        if (!e.target || e.target.name !== 'quantity') return;
        var form = Elixir_GetProductForm();
        if (!form || !form.contains(e.target)) return;
        var qty = parseInt(e.target.value, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        document.dispatchEvent(new CustomEvent('quantity:changed', {
            bubbles: true,
            detail: { quantity: qty }
        }));
    });
}
Elixir_InitProductFormQuantityListener();

/* ---------------------------------------------------------------------------------------------
 * Add-ons chosen with a "toggle" Product Upsell block (snippets/product-upsell-block.liquid).
 * The toggle only marks the add-on as chosen (assets/upsell-simple.js, no cart call). When the
 * product form is submitted, the chosen add-ons are appended to the SAME /cart/add request as the
 * product or the Quantity Break bundle, so the cart drawer opens once with everything.
 * Used by assets/product-form.js (submit) and skipToCheckout() in snippets/product-info.liquid.
 * ------------------------------------------------------------------------------------------- */

// Variant ids of the add-ons toggled on in the same section as the product form (one per add-on).
function Elixir_GetSelectedAddonVariantIds(form) {
    if (!form) return [];
    var scope = form.closest('.shopify-section') || document;
    var ids = [];
    scope.querySelectorAll('input.upsell-toggle-input').forEach(function (toggle) {
        if (!toggle.checked) return;
        var upsellForm = toggle.dataset.formId ? document.getElementById(toggle.dataset.formId) : null;
        var idInput = upsellForm ? upsellForm.querySelector('input[name="id"]') : null;
        var id = idInput && idInput.value ? String(idInput.value) : '';
        if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
}

function Elixir_CloneFormData(formData) {
    var copy = new FormData();
    formData.forEach(function (value, key) {
        copy.append(key, value);
    });
    return copy;
}

// Converts a single-product payload (id / quantity / selling_plan / properties[x]) to items[1][...].
// Returns false when there is nothing to convert (no id).
function Elixir_FormDataToItems(formData) {
    var id = formData.get('id');
    if (!id) return false;
    var quantity = parseInt(formData.get('quantity'), 10);
    if (isNaN(quantity) || quantity < 1) quantity = 1;
    var sellingPlan = formData.get('selling_plan');
    var properties = [];
    formData.forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match) properties.push([match[1], value]);
    });
    formData.delete('id');
    formData.delete('quantity');
    formData.delete('selling_plan');
    properties.forEach(function (p) {
        formData.delete('properties[' + p[0] + ']');
    });
    formData.append('items[1][id]', String(id));
    formData.append('items[1][quantity]', String(quantity));
    if (sellingPlan) formData.append('items[1][selling_plan]', String(sellingPlan));
    properties.forEach(function (p) {
        formData.append('items[1][properties][' + p[0] + ']', p[1]);
    });
    return true;
}

// Resolves with a NEW FormData (product/bundle + chosen add-ons, items[] format) or null when no add-on
// has to be added. The original formData is never modified (callers keep it as a fallback).
// An add-on already in the cart is not added again: the toggle means "I want it in my order".
function Elixir_ProductFormWithAddons(form, formData) {
    var ids = Elixir_GetSelectedAddonVariantIds(form);
    if (!ids.length || !formData) return Promise.resolve(null);

    var cartUrl = ((window.routes && window.routes.cart_url) || '/cart') + '.js';
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 2500) : null;

    return fetch(cartUrl, { headers: { Accept: 'application/json' }, signal: controller ? controller.signal : undefined })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (cart) {
            if (timer) clearTimeout(timer);
            var inCart = {};
            if (cart && Array.isArray(cart.items)) {
                cart.items.forEach(function (item) { inCart[String(item.variant_id)] = true; });
            }
            var toAdd = ids.filter(function (id) { return !inCart[id]; });
            if (!toAdd.length) return null;

            var payload = Elixir_CloneFormData(formData);
            var hasItems = false;
            payload.forEach(function (value, key) {
                if (/^items\[\d+\]\[id\]$/.test(key)) hasItems = true;
            });
            if (!hasItems && !Elixir_FormDataToItems(payload)) return null;

            var maxIndex = 0;
            payload.forEach(function (value, key) {
                var match = key.match(/^items\[(\d+)\]\[/);
                if (match) maxIndex = Math.max(maxIndex, parseInt(match[1], 10));
            });
            toAdd.forEach(function (id, i) {
                var index = maxIndex + 1 + i;
                payload.append('items[' + index + '][id]', id);
                payload.append('items[' + index + '][quantity]', '1');
            });
            return payload;
        });
}
